import { JsonHelper } from "../../helpers";

export default class TeamContent {

    static fromJson = (json) => {
        let content = new TeamContent();

        content.id = json.id;
        content.language = json.language;
        content.first_name = json.first_name;
        content.last_name = json.last_name;
        content.function = json.function;
        content.phone = json.phone;
        content.mobile = json.mobile;
        content.email = json.email;
        content.content = json.content != null ? json.content : '{}';

        content.additionalFieldValues = json.additional_field_values ? JsonHelper.tryParse(json.additional_field_values) : {};

        return content;
    }
}